import { Branch } from '@/api/model/branch'

export class ProjectAppraisalService  {
    constructor(
        public branch: Branch,
    ) { }

    static fromData(data: any): ProjectAppraisalService {
        if (data === null || data instanceof ProjectAppraisalService) {
            return data
        }

        return new ProjectAppraisalService(
            Branch.fromData(data.branch),
        )
    }
}
